<template>
  <div class="holder pt-1">
    <!-- <img :src="infoItem.image" class="ma-2 mr-3" /> -->
    <!-- <pdf src="https://sonive.com/static/Waltz%20No.%204%20free%20sheet%20music.pdf"></pdf> -->
    <embed :src="infoItem.url" type="application/pdf" max-width="200" />
    <h4 class="mt-1">{{ infoItem.title }}</h4>
    <div>{{ infoItem.subtitle }}</div>
    <p class="mr-2" v-html="infoItem.short_description"></p>
    <v-btn
      class="button"
      :href="infoItem.url"
      target="_blank"
      @click.native="
        window._paq.push(['trackEvent', 'Download', 'Click', infoItem.title])
        const response = fetch(infoItem.url)
        const blob = response.blob();
        const url = URL.createObjectURL(blob)
        window.open(url)

      "
      download
      color="success"
    >
      <div>Download {{infoItem.url.split('.').pop().toUpperCase()}}</div>
    </v-btn>
    <v-btn
      v-if="infoItem.bookUrl"
      class="button"
      :to="infoItem.bookUrl"
      @click.native="
        window._paq.push(['trackEvent', 'Full book', 'Click', infoItem.bookUrl])
      "
      download
      color="info"
    >
      <div>See book</div>
    </v-btn>
  </div>
</template>

<script>
// import pdf from 'vue-pdf'

export default {
  name: "FreeMusicItem",
  // components: {
  //   pdf
  // },
  props: {
    infoItem: Object,
  },
};
</script>

<style scoped>
.button {
  float: right;
}

img {
  width: 150px;
  float: left;
  margin: auto;
}

h4 {
  display: block;
}

p >>> p {
  font-size: 11px;
}

p {
  display: inline;
  height: 120px;
  max-height: 120px;
}

v-btn {
  margin: auto;
  margin-bottom: 2px;
}
</style>